module.exports = __webpack_public_path__ + "static/img/0025.9ba859b3.png";